import { c as _c } from "react/compiler-runtime";
import { useTranslation } from 'react-i18next';
import LogoCsob from '@/assets/logos/csob.svg';
import LogoSkippay from '@/assets/logos/skippay.svg';
import SocialBlog from '@/assets/logos/socialMedia/blog.svg';
import SocialFacebook from '@/assets/logos/socialMedia/facebook.svg';
import SocialLinkedin from '@/assets/logos/socialMedia/linkedin.svg';
import SocialYoutube from '@/assets/logos/socialMedia/youtube.svg';
import SocialInstagram from '@/assets/logos/socialMedia/instagram.svg';
import IconMail from '@/assets/icons/heroIcons/Mail.svg';
import { Link, LinkProps } from '@/components/links';
import LinkCategory from '@/sections/layout/Footer/LinksCategory';
import React from 'react';
import { EXTERNAL_LINKS, LINKS } from '@/constants/links';
import { CONTACT_EMAIL } from '@/constants/contacts';
import Image from 'next/image';
import { useIsSelectedLanguage } from '@/hooks/useIsSelectedLanguage';
import { FILES } from '@/constants/files';
import { Chat } from '@/sections/layout/Footer/Chat';
const year = new Date().getFullYear();
export const FOOTER_TEST_ID = 'footer';
function ContactUsCategory() {
  const $ = _c(8);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["core"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation(t0);
  let t1;
  if ($[1] !== t) {
    t1 = t("core:footer.category.contactUs");
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <p className="mb-3 text-base font-semibold text-white lg:text-xl">{t1}</p>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="inline-block"><Link to={`mailto:${CONTACT_EMAIL}`} analyticsParam={`${FOOTER_TEST_ID}Mail`} testId={`${FOOTER_TEST_ID}Mail`} className="text-sm text-white no-underline hover:text-white hover:underline"><span className="flex items-center gap-3"><IconMail className="h-7 w-7" /><span>{CONTACT_EMAIL}</span></span></Link></div>;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t2) {
    t4 = <div className="text-center lg:text-left">{t2}{t3}</div>;
    $[6] = t2;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
}
function DownloadAppCategory() {
  const $ = _c(27);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["core"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation(t0);
  let t1;
  if ($[1] !== t) {
    t1 = t("core:footer.category.app");
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <p className="mb-3 text-base font-semibold text-white lg:text-xl">{t1}</p>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = EXTERNAL_LINKS();
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const t4 = t3.appStore;
  let t5;
  if ($[6] !== t) {
    t5 = t("core:link.appStore");
    $[6] = t;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t5) {
    t6 = <span className="sr-only">{t5}</span>;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <Image src={`/images/buttons/${process.env.NEXT_PUBLIC_LANGUAGE}/app-store.svg`} alt="App Store" width={156} height={40} />;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t6) {
    t8 = <Link to={t4} analyticsParam={`${FOOTER_TEST_ID}AppStore`} testId={`${FOOTER_TEST_ID}AppStore`}>{t6}{t7}</Link>;
    $[11] = t6;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = EXTERNAL_LINKS();
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  const t10 = t9.googlePlay;
  let t11;
  if ($[14] !== t) {
    t11 = t("core:link.googlePlay");
    $[14] = t;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[16] !== t11) {
    t12 = <span className="sr-only">{t11}</span>;
    $[16] = t11;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  let t13;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <Image src={`/images/buttons/${process.env.NEXT_PUBLIC_LANGUAGE}/google-play.svg`} alt="Google Play" width={156} height={40} />;
    $[18] = t13;
  } else {
    t13 = $[18];
  }
  let t14;
  if ($[19] !== t12) {
    t14 = <Link to={t10} analyticsParam={`${FOOTER_TEST_ID}GooglePlay`} testId={`${FOOTER_TEST_ID}GooglePlay`}>{t12}{t13}</Link>;
    $[19] = t12;
    $[20] = t14;
  } else {
    t14 = $[20];
  }
  let t15;
  if ($[21] !== t14 || $[22] !== t8) {
    t15 = <div className="flex flex-col items-center gap-2 lg:items-start">{t8}{t14}</div>;
    $[21] = t14;
    $[22] = t8;
    $[23] = t15;
  } else {
    t15 = $[23];
  }
  let t16;
  if ($[24] !== t15 || $[25] !== t2) {
    t16 = <div className="text-center lg:text-left">{t2}{t15}</div>;
    $[24] = t15;
    $[25] = t2;
    $[26] = t16;
  } else {
    t16 = $[26];
  }
  return t16;
}
function SocialsCategory() {
  const $ = _c(54);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["core"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation(t0);
  let t1;
  if ($[1] !== t) {
    t1 = t("core:footer.category.social");
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <p className="mb-3 text-base font-semibold text-white lg:text-xl">{t1}</p>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = EXTERNAL_LINKS();
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const t4 = t3.facebook;
  let t5;
  if ($[6] !== t) {
    t5 = t("core:link.facebook");
    $[6] = t;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t5) {
    t6 = <span className="sr-only">{t5}</span>;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <SocialFacebook />;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t6) {
    t8 = <Link to={t4} analyticsParam={`${FOOTER_TEST_ID}Facebook`} testId={`${FOOTER_TEST_ID}Facebook`}>{t6}{t7}</Link>;
    $[11] = t6;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = EXTERNAL_LINKS();
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  const t10 = t9.youtube;
  let t11;
  if ($[14] !== t) {
    t11 = t("core:link.youtube");
    $[14] = t;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[16] !== t11) {
    t12 = <span className="sr-only">{t11}</span>;
    $[16] = t11;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  let t13;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <SocialYoutube />;
    $[18] = t13;
  } else {
    t13 = $[18];
  }
  let t14;
  if ($[19] !== t12) {
    t14 = <Link to={t10} analyticsParam={`${FOOTER_TEST_ID}Youtube`} testId={`${FOOTER_TEST_ID}Youtube`}>{t12}{t13}</Link>;
    $[19] = t12;
    $[20] = t14;
  } else {
    t14 = $[20];
  }
  let t15;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = EXTERNAL_LINKS();
    $[21] = t15;
  } else {
    t15 = $[21];
  }
  const t16 = t15.linkedIn;
  let t17;
  if ($[22] !== t) {
    t17 = t("core:link.linkedin");
    $[22] = t;
    $[23] = t17;
  } else {
    t17 = $[23];
  }
  let t18;
  if ($[24] !== t17) {
    t18 = <span className="sr-only">{t17}</span>;
    $[24] = t17;
    $[25] = t18;
  } else {
    t18 = $[25];
  }
  let t19;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <SocialLinkedin />;
    $[26] = t19;
  } else {
    t19 = $[26];
  }
  let t20;
  if ($[27] !== t18) {
    t20 = <Link to={t16} analyticsParam={`${FOOTER_TEST_ID}Linkedin`} testId={`${FOOTER_TEST_ID}Linkedin`}>{t18}{t19}</Link>;
    $[27] = t18;
    $[28] = t20;
  } else {
    t20 = $[28];
  }
  let t21;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = EXTERNAL_LINKS();
    $[29] = t21;
  } else {
    t21 = $[29];
  }
  const t22 = t21.instagram;
  let t23;
  if ($[30] !== t) {
    t23 = t("core:link.instagram");
    $[30] = t;
    $[31] = t23;
  } else {
    t23 = $[31];
  }
  let t24;
  if ($[32] !== t23) {
    t24 = <span className="sr-only">{t23}</span>;
    $[32] = t23;
    $[33] = t24;
  } else {
    t24 = $[33];
  }
  let t25;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = <SocialInstagram />;
    $[34] = t25;
  } else {
    t25 = $[34];
  }
  let t26;
  if ($[35] !== t24) {
    t26 = <Link to={t22} analyticsParam={`${FOOTER_TEST_ID}Instagram`} testId={`${FOOTER_TEST_ID}Instagram`}>{t24}{t25}</Link>;
    $[35] = t24;
    $[36] = t26;
  } else {
    t26 = $[36];
  }
  let t27;
  if ($[37] === Symbol.for("react.memo_cache_sentinel")) {
    t27 = EXTERNAL_LINKS();
    $[37] = t27;
  } else {
    t27 = $[37];
  }
  const t28 = t27.blog;
  let t29;
  if ($[38] !== t) {
    t29 = t("core:link.blog");
    $[38] = t;
    $[39] = t29;
  } else {
    t29 = $[39];
  }
  let t30;
  if ($[40] !== t29) {
    t30 = <span className="sr-only">{t29}</span>;
    $[40] = t29;
    $[41] = t30;
  } else {
    t30 = $[41];
  }
  let t31;
  if ($[42] === Symbol.for("react.memo_cache_sentinel")) {
    t31 = <SocialBlog />;
    $[42] = t31;
  } else {
    t31 = $[42];
  }
  let t32;
  if ($[43] !== t30) {
    t32 = <Link to={t28} analyticsParam={`${FOOTER_TEST_ID}Blog`} testId={`${FOOTER_TEST_ID}Blog`}>{t30}{t31}</Link>;
    $[43] = t30;
    $[44] = t32;
  } else {
    t32 = $[44];
  }
  let t33;
  if ($[45] !== t14 || $[46] !== t20 || $[47] !== t26 || $[48] !== t32 || $[49] !== t8) {
    t33 = <div className="flex items-center justify-center gap-2 lg:justify-start">{t8}{t14}{t20}{t26}{t32}</div>;
    $[45] = t14;
    $[46] = t20;
    $[47] = t26;
    $[48] = t32;
    $[49] = t8;
    $[50] = t33;
  } else {
    t33 = $[50];
  }
  let t34;
  if ($[51] !== t2 || $[52] !== t33) {
    t34 = <div className="text-center lg:text-left">{t2}{t33}</div>;
    $[51] = t2;
    $[52] = t33;
    $[53] = t34;
  } else {
    t34 = $[53];
  }
  return t34;
}
function CooperationCategory() {
  const $ = _c(16);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["core"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation(t0);
  const isCsLanguage = useIsSelectedLanguage("cs");
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = LINKS();
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = t1.homepage;
  let t3;
  if ($[2] !== t) {
    t3 = t("core:footer.skippay");
    $[2] = t;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t3) {
    t4 = <span className="sr-only">{t3}</span>;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <LogoSkippay className="absolute bottom-0 left-0 h-[1px] w-[1px] opacity-0" />;
    t6 = <LogoSkippay />;
    $[6] = t5;
    $[7] = t6;
  } else {
    t5 = $[6];
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t4) {
    t7 = <Link to={t2} analyticsParam={`${FOOTER_TEST_ID}Skippay`} testId={`${FOOTER_TEST_ID}Skippay`}>{t4}{t5}{t6}</Link>;
    $[8] = t4;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== isCsLanguage || $[11] !== t) {
    t8 = isCsLanguage && <><div className="mx-4 h-8 w-px bg-gray-100" /><Link to={EXTERNAL_LINKS().csob} analyticsParam={`${FOOTER_TEST_ID}Csob`} testId={`${FOOTER_TEST_ID}Csob`}><span className="sr-only">{t("core:footer.cooperation")}</span><LogoCsob /></Link></>;
    $[10] = isCsLanguage;
    $[11] = t;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== t7 || $[14] !== t8) {
    t9 = <div className="relative flex items-center justify-center lg:justify-start">{t7}{t8}</div>;
    $[13] = t7;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  return t9;
}
export function Footer() {
  const $ = _c(106);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["core"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation(t0);
  const isCsLanguage = useIsSelectedLanguage("cs");
  const isSkLanguage = useIsSelectedLanguage("sk");
  let t1;
  if ($[1] !== isCsLanguage || $[2] !== t) {
    t1 = isCsLanguage ? {
      products: [{
        title: t("core:products.deferredPayment"),
        to: LINKS().deferredPayment,
        id: "deferredPayment"
      }, {
        title: t("core:link.payInThree"),
        to: LINKS().payInThree,
        id: "payInThree"
      }, {
        title: t("core:products.installments"),
        to: LINKS().installments,
        id: "installments"
      }, {
        title: t("core:products.loan.short"),
        to: LINKS().loan,
        id: "loan"
      }, {
        title: t("core:products.revolving"),
        to: LINKS().revolving,
        id: "revolving"
      }, {
        title: t("core:link.mini"),
        to: `${LINKS().packages}#mini`,
        id: "packages"
      }, {
        title: t("core:link.rewards"),
        to: LINKS().rewards,
        id: "rewards"
      }, {
        title: t("core:link.card"),
        to: LINKS().card,
        id: "card"
      }, {
        title: t("core:products.mobileApp"),
        to: LINKS().mobileApp,
        id: "mobileApp"
      }, {
        title: t("core:products.insuranceAndWarranty"),
        to: LINKS().insuranceAndWarranty,
        id: "insuranceAndWarranty"
      }, {
        title: t("core:products.cashback"),
        to: EXTERNAL_LINKS().cashback,
        id: "cashback"
      }],
      aboutUs: [{
        title: t("core:products.aboutUs"),
        to: LINKS().aboutCompany,
        id: "aboutUs"
      }, {
        title: t("core:products.whereToShop"),
        to: LINKS().whereToShop,
        id: "whereToShop"
      }, {
        title: t("core:products.career"),
        to: LINKS().career,
        id: "career"
      }, {
        title: t("core:products.forMedia"),
        to: LINKS().forMedia,
        id: "forMedia"
      }, {
        title: t("core:link.blog"),
        to: EXTERNAL_LINKS().blog,
        id: "blog"
      }, {
        title: t("core:link.podcast"),
        to: EXTERNAL_LINKS().podcast,
        id: "podcast"
      }],
      interestedIn: [{
        title: t("core:products.faq"),
        to: LINKS().faq,
        id: "faq"
      }, {
        title: t("core:products.termsAndConditions"),
        to: LINKS().termsAndConditions,
        id: "termsAndConditions"
      }, {
        title: t("core:products.pricing"),
        to: LINKS().pricing,
        id: "pricing"
      }, {
        title: t("core:link.informationMemorandum"),
        to: LINKS().informationMemorandum,
        id: "informationMemorandum"
      }, {
        title: t("core:link.personalInformation"),
        to: LINKS().personalInformation,
        id: "personalInformation"
      }, {
        title: t("core:link.exchangeRates"),
        to: LINKS().exchangeRates,
        id: "exchangeRates"
      }, {
        title: t("core:link.contacts"),
        to: LINKS().contact,
        id: "contacts"
      }, {
        title: t("core:link.whistleblowing"),
        to: LINKS().whistleblowing,
        id: "whistleblowing"
      }],
      forPartners: [{
        title: t("core:products.forEshops"),
        to: LINKS().forEshops,
        id: "forEshops"
      }, {
        title: t("core:products.forDevelopersApi"),
        to: LINKS().forDevelopers,
        id: "forDevelopers"
      }, {
        title: t("core:link.affiliate"),
        to: EXTERNAL_LINKS().affiliate,
        id: "affiliate"
      }, {
        title: t("core:products.gcss"),
        to: LINKS().gcssLandingPage,
        id: "gcss"
      }],
      moreInformation: [{
        title: t("core:link.testimonial"),
        to: LINKS().testimonial,
        id: "testimonial"
      }, {
        title: t("core:link.howToPay"),
        to: LINKS().howToPay,
        id: "howToPay"
      }, {
        title: t("core:link.referrals"),
        to: LINKS().referral,
        id: "referrals"
      }, {
        title: t("core:link.paymentOnDelivery"),
        to: LINKS().paymentOnDelivery,
        id: "paymentOnDelivery"
      }, {
        title: t("core:link.overdraft"),
        to: LINKS().overdraft,
        id: "overdraft"
      }, {
        title: t("core:link.creditCard"),
        to: LINKS().creditCard,
        id: "creditCard"
      }, {
        title: t("core:link.deferredPayment"),
        to: LINKS().aboutDeferredPayment,
        id: "aboutDeferredPayment"
      }, {
        title: t("core:link.paymentByCard"),
        to: LINKS().paymentByCard,
        id: "paymentByCard"
      }, {
        title: t("core:link.onlinePayment"),
        to: LINKS().onlinePayment,
        id: "onlinePayment"
      }, {
        title: t("core:link.paymentGateway"),
        to: LINKS().paymentGateway,
        id: "paymentGateway"
      }, {
        title: t("core:link.loans"),
        to: LINKS().loans,
        id: "loans"
      }, {
        title: t("core:link.installmentPayment"),
        to: LINKS().installmentPayment,
        id: "installmentPayment"
      }, {
        title: t("core:link.glossaryOfTerms"),
        to: EXTERNAL_LINKS().glossaryOfTerms,
        id: "glossaryOfTerms"
      }, {
        title: t("core:products.promotions"),
        to: LINKS().promotions,
        id: "promotions"
      }, {
        title: t("core:link.shopWisely"),
        to: LINKS().shopWisely,
        id: "shopWisely"
      }, {
        title: t("core:link.termsAccessibility"),
        to: FILES().termsAccessibility,
        id: "termsAccessibility",
        target: "_blank" as LinkProps['target']
      }, {
        title: t("core:link.privacySettings"),
        to: LINKS().privacySettings,
        id: "privacySettings"
      }]
    } : {
      products: [{
        title: t("core:link.payInThree"),
        to: LINKS().payInThree,
        id: "payInThree"
      }, {
        title: t("core:products.mobileApp"),
        to: LINKS().mobileApp,
        id: "mobileApp"
      }],
      aboutUs: [{
        title: t("core:products.aboutUs"),
        to: LINKS().aboutCompany,
        id: "aboutUs"
      }, {
        title: t("core:products.whereToShop"),
        to: LINKS().whereToShop,
        id: "whereToShop"
      }, {
        title: t("core:products.forMedia"),
        to: LINKS().forMedia,
        id: "forMedia"
      }],
      interestedIn: [{
        title: t("core:products.faq"),
        to: LINKS().faq,
        id: "faq"
      }, {
        title: t("core:products.termsAndConditions"),
        to: LINKS().termsAndConditions,
        id: "termsAndConditions"
      }, {
        title: t("core:products.pricing"),
        to: LINKS().pricing,
        id: "pricing"
      }, {
        title: t("core:link.informationMemorandum"),
        to: LINKS().informationMemorandum,
        id: "informationMemorandum"
      }, {
        title: t("core:link.personalInformation"),
        to: LINKS().personalInformation,
        id: "personalInformation"
      }, {
        title: t("core:link.contacts"),
        to: LINKS().contact,
        id: "contacts"
      }, {
        title: t("core:link.whistleblowing"),
        to: LINKS().whistleblowing,
        id: "whistleblowing"
      }, {
        title: t("core:link.privacySettings"),
        to: LINKS().privacySettings,
        id: "privacySettings"
      }],
      forPartners: [{
        title: t("core:products.forEshops"),
        to: LINKS().forEshops,
        id: "forEshops"
      }, {
        title: t("core:products.forDevelopersApi"),
        to: LINKS().forDevelopers,
        id: "forDevelopers"
      }],
      moreInformation: []
    };
    $[1] = isCsLanguage;
    $[2] = t;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const links = t1;
  let t2;
  if ($[4] !== isCsLanguage || $[5] !== isSkLanguage) {
    t2 = (isCsLanguage || isSkLanguage) && <Chat />;
    $[4] = isCsLanguage;
    $[5] = isSkLanguage;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = LINKS();
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const t4 = t3.homepage;
  let t5;
  if ($[8] !== t) {
    t5 = t("core:footer.skippay");
    $[8] = t;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t5) {
    t6 = <span className="sr-only">{t5}</span>;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <LogoSkippay />;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t6) {
    t8 = <div className="mx-auto inline-block"><Link to={t4} analyticsParam={`${FOOTER_TEST_ID}Skippay`} testId={`${FOOTER_TEST_ID}Skippay`}>{t6}{t7}</Link></div>;
    $[13] = t6;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t) {
    t9 = t("core:footer.category.products");
    $[15] = t;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== links.products || $[18] !== t9) {
    t10 = <LinkCategory title={t9} links={links.products} isAccordion={true} />;
    $[17] = links.products;
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== t) {
    t11 = t("core:footer.category.aboutUs");
    $[20] = t;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== links.aboutUs || $[23] !== t11) {
    t12 = <LinkCategory title={t11} links={links.aboutUs} isAccordion={true} />;
    $[22] = links.aboutUs;
    $[23] = t11;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== t) {
    t13 = t("core:footer.category.interestedIn");
    $[25] = t;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== links.interestedIn || $[28] !== t13) {
    t14 = <LinkCategory title={t13} links={links.interestedIn} isAccordion={true} />;
    $[27] = links.interestedIn;
    $[28] = t13;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  let t15;
  if ($[30] !== t) {
    t15 = t("core:footer.category.forPartners");
    $[30] = t;
    $[31] = t15;
  } else {
    t15 = $[31];
  }
  let t16;
  if ($[32] !== links.forPartners || $[33] !== t15) {
    t16 = <LinkCategory title={t15} links={links.forPartners} isAccordion={true} />;
    $[32] = links.forPartners;
    $[33] = t15;
    $[34] = t16;
  } else {
    t16 = $[34];
  }
  let t17;
  if ($[35] !== isCsLanguage || $[36] !== links.moreInformation || $[37] !== t) {
    t17 = isCsLanguage && <LinkCategory title={t("core:footer.category.moreInformation")} links={links.moreInformation} isAccordion={true} />;
    $[35] = isCsLanguage;
    $[36] = links.moreInformation;
    $[37] = t;
    $[38] = t17;
  } else {
    t17 = $[38];
  }
  let t18;
  if ($[39] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <div className="mt-8 mb-2.5 h-px bg-white opacity-25" />;
    $[39] = t18;
  } else {
    t18 = $[39];
  }
  let t19;
  if ($[40] !== t10 || $[41] !== t12 || $[42] !== t14 || $[43] !== t16 || $[44] !== t17) {
    t19 = <div>{t10}{t12}{t14}{t16}{t17}{t18}</div>;
    $[40] = t10;
    $[41] = t12;
    $[42] = t14;
    $[43] = t16;
    $[44] = t17;
    $[45] = t19;
  } else {
    t19 = $[45];
  }
  let t20;
  let t21;
  if ($[46] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <ContactUsCategory />;
    t21 = <DownloadAppCategory />;
    $[46] = t20;
    $[47] = t21;
  } else {
    t20 = $[46];
    t21 = $[47];
  }
  let t22;
  if ($[48] !== isCsLanguage) {
    t22 = isCsLanguage && <SocialsCategory />;
    $[48] = isCsLanguage;
    $[49] = t22;
  } else {
    t22 = $[49];
  }
  let t23;
  let t24;
  if ($[50] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = <CooperationCategory />;
    t24 = <div className="h-px bg-white opacity-25" />;
    $[50] = t23;
    $[51] = t24;
  } else {
    t23 = $[50];
    t24 = $[51];
  }
  let t25;
  if ($[52] !== t19 || $[53] !== t22 || $[54] !== t8) {
    t25 = <div className="flex flex-col gap-14 pt-14 lg:hidden">{t8}{t19}{t20}{t21}{t22}{t23}{t24}</div>;
    $[52] = t19;
    $[53] = t22;
    $[54] = t8;
    $[55] = t25;
  } else {
    t25 = $[55];
  }
  let t26;
  if ($[56] !== t) {
    t26 = t("core:footer.category.products");
    $[56] = t;
    $[57] = t26;
  } else {
    t26 = $[57];
  }
  let t27;
  if ($[58] !== links.products || $[59] !== t26) {
    t27 = <LinkCategory title={t26} links={links.products} />;
    $[58] = links.products;
    $[59] = t26;
    $[60] = t27;
  } else {
    t27 = $[60];
  }
  let t28;
  if ($[61] !== t) {
    t28 = t("core:footer.category.aboutUs");
    $[61] = t;
    $[62] = t28;
  } else {
    t28 = $[62];
  }
  let t29;
  if ($[63] !== links.aboutUs || $[64] !== t28) {
    t29 = <LinkCategory title={t28} links={links.aboutUs} />;
    $[63] = links.aboutUs;
    $[64] = t28;
    $[65] = t29;
  } else {
    t29 = $[65];
  }
  let t30;
  if ($[66] !== t) {
    t30 = t("core:footer.category.interestedIn");
    $[66] = t;
    $[67] = t30;
  } else {
    t30 = $[67];
  }
  let t31;
  if ($[68] !== links.interestedIn || $[69] !== t30) {
    t31 = <LinkCategory title={t30} links={links.interestedIn} />;
    $[68] = links.interestedIn;
    $[69] = t30;
    $[70] = t31;
  } else {
    t31 = $[70];
  }
  let t32;
  if ($[71] !== t) {
    t32 = t("core:footer.category.forPartners");
    $[71] = t;
    $[72] = t32;
  } else {
    t32 = $[72];
  }
  let t33;
  if ($[73] !== links.forPartners || $[74] !== t32) {
    t33 = <LinkCategory title={t32} links={links.forPartners} />;
    $[73] = links.forPartners;
    $[74] = t32;
    $[75] = t33;
  } else {
    t33 = $[75];
  }
  let t34;
  if ($[76] === Symbol.for("react.memo_cache_sentinel")) {
    t34 = <ContactUsCategory />;
    $[76] = t34;
  } else {
    t34 = $[76];
  }
  let t35;
  if ($[77] !== t33) {
    t35 = <div className="flex flex-col gap-8">{t33}{t34}</div>;
    $[77] = t33;
    $[78] = t35;
  } else {
    t35 = $[78];
  }
  let t36;
  if ($[79] === Symbol.for("react.memo_cache_sentinel")) {
    t36 = <DownloadAppCategory />;
    $[79] = t36;
  } else {
    t36 = $[79];
  }
  let t37;
  if ($[80] !== isCsLanguage) {
    t37 = <div className="flex flex-col gap-8">{t36}{isCsLanguage ? <SocialsCategory /> : <div className="mt-8"><CooperationCategory /></div>}</div>;
    $[80] = isCsLanguage;
    $[81] = t37;
  } else {
    t37 = $[81];
  }
  let t38;
  if ($[82] !== t27 || $[83] !== t29 || $[84] !== t31 || $[85] !== t35 || $[86] !== t37) {
    t38 = <div className="flex justify-between gap-20 py-20">{t27}{t29}{t31}{t35}{t37}</div>;
    $[82] = t27;
    $[83] = t29;
    $[84] = t31;
    $[85] = t35;
    $[86] = t37;
    $[87] = t38;
  } else {
    t38 = $[87];
  }
  let t39;
  if ($[88] !== isCsLanguage || $[89] !== links.moreInformation || $[90] !== t) {
    t39 = isCsLanguage && <div className="flex justify-between gap-20 py-20 pt-5"><div className="max-w-2xl"><LinkCategory title={t("core:footer.category.moreInformation")} links={links.moreInformation} onRow={true} /></div><CooperationCategory /></div>;
    $[88] = isCsLanguage;
    $[89] = links.moreInformation;
    $[90] = t;
    $[91] = t39;
  } else {
    t39 = $[91];
  }
  let t40;
  if ($[92] !== t38 || $[93] !== t39) {
    t40 = <div className="hidden lg:block">{t38}{t39}</div>;
    $[92] = t38;
    $[93] = t39;
    $[94] = t40;
  } else {
    t40 = $[94];
  }
  let t41;
  if ($[95] !== t) {
    t41 = t("core:footer.copy", {
      year
    });
    $[95] = t;
    $[96] = t41;
  } else {
    t41 = $[96];
  }
  let t42;
  if ($[97] !== t41) {
    t42 = <div className="py-6 text-center"><p className="text-sm text-gray-100">{t41}</p></div>;
    $[97] = t41;
    $[98] = t42;
  } else {
    t42 = $[98];
  }
  let t43;
  if ($[99] !== t25 || $[100] !== t40 || $[101] !== t42) {
    t43 = <footer className="content-visibility-auto relative z-30 bg-gray-900 px-5"><div className="relative m-auto w-full max-w-[38.5rem] lg:max-w-292">{t25}{t40}{t42}</div></footer>;
    $[99] = t25;
    $[100] = t40;
    $[101] = t42;
    $[102] = t43;
  } else {
    t43 = $[102];
  }
  let t44;
  if ($[103] !== t2 || $[104] !== t43) {
    t44 = <>{t2}{t43}</>;
    $[103] = t2;
    $[104] = t43;
    $[105] = t44;
  } else {
    t44 = $[105];
  }
  return t44;
}